import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className='about-section'>
    <h1>About us</h1>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Et culpa atque, omnis consectetur perspiciatis illo, nam fugit, in libero autem possimus blanditiis ad. Fugiat eaque ab eius voluptas laboriosam quidem mollitia saepe repellendus, laborum corporis culpa explicabo nobis debitis non. Earum, neque rerum temporibus ratione natus animi numquam officiis deleniti?</p>
    </div>
  )
}

export default About;